import { NgModule } from '@angular/core';
import { LibTransactionsIconComponent } from './lib-transactions-icon.component';

@NgModule({
  declarations: [LibTransactionsIconComponent],
  imports: [],
  exports: [LibTransactionsIconComponent],
})
export class LibTransactionsIconModule {}
